<template>
  <div class="content">
    <!-- 头部部分 -->
    <div class="head">
      <!-- 展示的搜索条件 -->
      <div class="searchOne">
        <!-- <el-select v-model="queryParams.type" filterable placeholder="状态" @change="search" clearable>
          <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select> -->
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable></el-input>
        <el-input v-model="queryParams.phone" placeholder="签约手机号"  @keyup.enter.native="search" clearable></el-input>
      </div>
      <!-- 搜索的按钮 -->
      <span class="span-but">
        <button type="button" class="el-button icon-button-auto el-button--default el-button--small" @click="hidden">
          <i class="el-icon-d-arrow-right" :class="{rotating:an}"></i>
        </button>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetForm">重置</el-button>
      </span>
      <!-- 隐藏的搜索条件 -->
      <div v-show="an" class="array-class">
        <el-select v-model="queryParams.status" filterable placeholder="签约状态" @change="search" clearable>
          <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-date-picker
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="searchTime"
          @change="search"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>

      </div>
    </div>
    <!-- 内容部分 -->
    <div class="content-class">
      <div style="margin-top: 10px">
        <el-table :data="tableData" border  @sort-change="tableSortChange">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" class="demo-table-expand">
                <el-form-item label="第一次扣款时间：">
                  <span>{{ props.row.firstDebitTime }}</span>
                </el-form-item>
                <el-form-item label="签约套餐：">
                  <span>{{ props.row.productName }}</span>
                </el-form-item>
                <el-form-item label="签约账户：">
                  <span>{{ props.row.appName }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="iccid" label="ICCID" align="center" width="185px">
            <template slot-scope="scope">
              <div style="color: #4466AD;cursor: pointer;text-decoration: underline;" class="complaint-class" @click="jumpCardDetails(scope.row.iccid)">{{ scope.row.iccid }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="签约手机号" align="center"></el-table-column>
          <el-table-column prop="agreementAccount" label="用户账户" align="center"></el-table-column>
          <el-table-column prop="createTime" label="签约时间" align="center" sortable="custom" width="140px"></el-table-column>
          <el-table-column prop="nextDebitTime" label="下次扣款时间" align="center" sortable="custom" width="140px"></el-table-column>
          <el-table-column prop="lastDebitTime" label="最后扣款时间" align="center" sortable="custom" width="140px"></el-table-column>
          <el-table-column prop="unSignTime" label="解约时间" align="center" sortable="custom" width="140px"></el-table-column>
          <el-table-column prop="price" label="签约价格" align="center" width="85px"></el-table-column>
          <el-table-column prop="renewalPrice" label="续费价格" align="center" width="85px"></el-table-column>
          <!-- <el-table-column prop="productName" label="签约套餐" align="center" width="180px"></el-table-column> -->
          <el-table-column prop="status" label="签约状态" align="center">
            <template slot-scope="{row}">
              <span v-if="row.status == '0'">待签约</span>
              <el-tag v-else-if="row.status =='1'">已签约</el-tag>
              <el-tag v-else-if="row.status =='2'" type="warning">已解约</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click=" detailsButton(scope.row.id)" style="background:#24D2B5;border: 1px solid #24D2B5;">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { agreementList } from "@/api/api.js"; //不分页套餐列表
export default {
  name: "autoRenewalList",
  data() {
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      an:false,
      searchTime:[],
      operator:[
        { value: 1, label: "已签约" },
        { value: 2, label: "已解约" },
      ],
      sortOrder:"",
      sortName:"",
    }
  },
  methods: {
    hidden(){
      this.an = this.an == false ? true : false;
    },
    // 获取列表的数据
    initData(){
      let params ={
        model:{
          ...this.queryParams,
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      // 搜索日期
      if (this.searchTime && this.searchTime[0]) {
        params.model.startTime = this.searchTime[0];
        params.model.endTime = this.searchTime[1];
      }
      agreementList(params).then(res=>{
        if(res.data.code == 200){
          this.total = res.data.data.total;
          this.tableData = res.data.data.records;
          this.tableData.map((item,index) => {
            item.ids = index + 1;
          })
        }
      })
    },
  // 跳转iccid详情
    jumpCardDetails(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
    // 跳转详情
    detailsButton(id){
      this.$router.push({path:"/userCenter/renewalDetails",query:{id: id}});
    },
    // 搜索
    search() {
      this.page = 1;
      this.tableData = [];
      this.initData();
    },
    // 重置
    resetForm() {
      for (var i in this.queryParams) {
        this.queryParams[i] = null;
      };
      this.searchTime = [];
      this.search();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      if(val.prop == "createTime"){
        this.sortName = "create_time"
      }else if(val.prop == "nextDebitTime"){
        this.sortName = "next_debit_time"
      }else if(val.prop == "lastDebitTime"){
        this.sortName = "last_debit_time"
      }else if(val.prop == "unSignTime"){
        this.sortName = "un_sign_time"
      }
      this.initData();
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    // setInterval(() => {
    //   this.initData();
    //   this.updateButton(12)
    // }, 1000);
  },

};
</script>

<style scoped lang="less">
.cell button{
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.demo-table-expand{
  display: flex;
  flex-wrap:wrap
}
.demo-table-expand .el-form-item {
  margin-bottom: 10px;
  width: 50%;
}
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
</style>


